module.exports = __webpack_public_path__ + "img/lock-open.eb0885c5.svg";